import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { CountryContext } from "../../../..";
import { useQuery } from "@apollo/client";
import { returnsPageQuery } from "../../../../Operations/Queries";
import DashBoardTable from "../../../../Components/Dashboard_Table/DashboardTable";
import NoProductFound from "../../../../Components/Noproduct/NoProductFound";
import {
  Box,
  CircularProgress,
  MenuItem,
  Pagination,
  Select,
  Stack,
  Typography,
} from "@mui/material";
import MobileTable from "../../../../Components/Mobile_Table/MobileTable";

interface BeforeDeliveryProps {
  array: { value: number; label: string }[];
  currency: string;
  menuItems: string[];
  selectedMenuItem: string;
  setErrorMessage : any;
}

const BeforeDelivery: React.FC<BeforeDeliveryProps> = ({
  array,
  currency,
  menuItems,
  selectedMenuItem,
  setErrorMessage
}) => {
  const [beforeDeliveryOrders, setBeforeDeliveryOrders] = useState<any[]>([]);
  const [pageSize, setPageSize] = useState<number>(10);
  const [currentPage, setCurrentPage] = useState(1);
  const loggedInToken = localStorage.getItem("loggedInCust");
  const { t }: { t: (key: string) => string } = useTranslation();
  const { store } = useContext(CountryContext);

  const {
    data: returnsBeforeDeliveryData,
    loading: loadingBeforeDeliveryData,
    error: beforeDeliveryError,
  } = useQuery(returnsPageQuery.RETURNS_BEFORE_DELIVERY, {
    context: {
      headers: {
        Authorization: loggedInToken
          ? `Bearer ${JSON.parse(loggedInToken)}`
          : "",
        Connection: "keep-alive",
        store: store,
      },
    },
  });

  // const {
  //   data: returnListData,
  //   refetch: refetchListData,
  //   loading: returnLoading,
  // } = useQuery(returnsPageQuery.RETURNS_AFTER_DELIVERY_REQUESTS, {
  //   variables: { type: "list" },
  //   fetchPolicy: "network-only",
  //   context: {
  //     headers: {
  //       Authorization: loggedInToken
  //         ? `Bearer ${JSON.parse(loggedInToken)}`
  //         : "",
  //       Connection: "keep-alive",
  //       store: store,
  //     },
  //   },
  // });

  // const returnRequestList = returnListData?.getReturnRequests;
  // const filteredReturnRequests = returnRequestList?.filter(
  //   (item: any) => item.status === "1"
  // );
  // console.log("returnRequestList", returnRequestList);

  if (beforeDeliveryError) {
    setErrorMessage(beforeDeliveryError?.message);
  }

  const BeforeDeliveryReturnsData = returnsBeforeDeliveryData?.returnOrders;

  // const BeforeDeliveryReturnsData = [
  //   {
  //     order_number: "ORD1001",
  //     item_id: "ITEM1001",
  //     date: "2025-02-01",
  //     delivery_date: "2025-02-05",
  //     return_date: "2025-02-03",
  //     status: "Pending",
  //     product_name: "Wireless Earbuds",
  //     product_sku: "EB1001",
  //     product_image: "https://placehold.co/300x250",
  //     price: 59.99,
  //     qty: 1,
  //     sub_total: 59.99,
  //     currency: "USD",
  //   },
  //   {
  //     order_number: "ORD1001",
  //     item_id: "ITEM1001",
  //     date: "2025-02-01",
  //     delivery_date: "2025-02-05",
  //     return_date: "2025-02-03",
  //     status: "Pending",
  //     product_name: "Wireless Earbuds",
  //     product_sku: "EB1001",
  //     product_image: "https://placehold.co/300x250",
  //     price: 59.99,
  //     qty: 1,
  //     sub_total: 59.99,
  //     currency: "USD",
  //   },
  //   {
  //     order_number: "ORD1002",
  //     item_id: "ITEM1002",
  //     date: "2025-02-02",
  //     delivery_date: "2025-02-06",
  //     return_date: "2025-02-04",
  //     status: "Approved",
  //     product_name: "Gaming Keyboard",
  //     product_sku: "KB1002",
  //     product_image: "https://placehold.co/300x250",
  //     price: 89.99,
  //     qty: 1,
  //     sub_total: 89.99,
  //     currency: "USD",
  //   },
  //   {
  //     order_number: "ORD1003",
  //     item_id: "ITEM1003",
  //     date: "2025-02-03",
  //     delivery_date: "2025-02-07",
  //     return_date: "2025-02-05",
  //     status: "Rejected",
  //     product_name: "USB-C Charging Cable",
  //     product_sku: "UC1003",
  //     product_image: "https://placehold.co/300x250",
  //     price: 12.99,
  //     qty: 2,
  //     sub_total: 25.98,
  //     currency: "USD",
  //   },
  //   {
  //     order_number: "ORD1004",
  //     item_id: "ITEM1004",
  //     date: "2025-02-04",
  //     delivery_date: "2025-02-08",
  //     return_date: "2025-02-06",
  //     status: "Pending",
  //     product_name: "Smartwatch",
  //     product_sku: "SW1004",
  //     product_image: "https://placehold.co/300x250",
  //     price: 199.99,
  //     qty: 1,
  //     sub_total: 199.99,
  //     currency: "USD",
  //   },
  //   {
  //     order_number: "ORD1005",
  //     item_id: "ITEM1005",
  //     date: "2025-02-05",
  //     delivery_date: "2025-02-09",
  //     return_date: "2025-02-07",
  //     status: "Approved",
  //     product_name: "Bluetooth Speaker",
  //     product_sku: "SP1005",
  //     product_image: "https://placehold.co/300x250",
  //     price: 49.99,
  //     qty: 1,
  //     sub_total: 49.99,
  //     currency: "USD",
  //   },
  //   {
  //     order_number: "ORD1006",
  //     item_id: "ITEM1006",
  //     date: "2025-02-06",
  //     delivery_date: "2025-02-10",
  //     return_date: "2025-02-08",
  //     status: "Rejected",
  //     product_name: "Laptop Cooling Pad",
  //     product_sku: "CP1006",
  //     product_image: "https://placehold.co/300x250",
  //     price: 29.99,
  //     qty: 1,
  //     sub_total: 29.99,
  //     currency: "USD",
  //   },
  //   {
  //     order_number: "ORD1007",
  //     item_id: "ITEM1007",
  //     date: "2025-02-07",
  //     delivery_date: "2025-02-11",
  //     return_date: "2025-02-09",
  //     status: "Pending",
  //     product_name: "Wireless Mouse",
  //     product_sku: "WM1007",
  //     product_image: "https://placehold.co/300x250",
  //     price: 25.99,
  //     qty: 1,
  //     sub_total: 25.99,
  //     currency: "USD",
  //   },
  //   {
  //     order_number: "ORD1008",
  //     item_id: "ITEM1008",
  //     date: "2025-02-08",
  //     delivery_date: "2025-02-12",
  //     return_date: "2025-02-10",
  //     status: "Approved",
  //     product_name: "External Hard Drive",
  //     product_sku: "HD1008",
  //     product_image: "https://placehold.co/300x250",
  //     price: 129.99,
  //     qty: 1,
  //     sub_total: 129.99,
  //     currency: "USD",
  //   },
  //   {
  //     order_number: "ORD1009",
  //     item_id: "ITEM1009",
  //     date: "2025-02-09",
  //     delivery_date: "2025-02-13",
  //     return_date: "2025-02-11",
  //     status: "Rejected",
  //     product_name: "USB Hub",
  //     product_sku: "UH1009",
  //     product_image: "https://placehold.co/300x250",
  //     price: 19.99,
  //     qty: 2,
  //     sub_total: 39.98,
  //     currency: "USD",
  //   },
  //   {
  //     order_number: "ORD1010",
  //     item_id: "ITEM1010",
  //     date: "2025-02-10",
  //     delivery_date: "2025-02-14",
  //     return_date: "2025-02-12",
  //     status: "Pending",
  //     product_name: "Mechanical Keyboard",
  //     product_sku: "MK1010",
  //     product_image: "https://placehold.co/300x250",
  //     price: 89.99,
  //     qty: 1,
  //     sub_total: 89.99,
  //     currency: "USD",
  //   },
  // ];

  const headCellsForBeforeDelivery = [
    {
      id: "order",
      numeric: false,
      disablePadding: false,
      label: t("Home_Dashboard.return.order"),
    },
    {
      id: "itemName",
      numeric: false,
      disablePadding: false,
      label: t("Home_Dashboard.return.itemName"),
    },
    {
      id: "itemPrice",
      numeric: true,
      disablePadding: false,
      label: `${t("Home_Dashboard.return.itemPrice")}(${currency})`,
    },
    {
      id: "quantity",
      numeric: true,
      disablePadding: false,
      label: t("Home_Dashboard.return.quantity"),
    },
    {
      id: "itemTotal",
      numeric: true,
      disablePadding: false,
      label: `${t("Home_Dashboard.return.itemTotal")}(${currency})`,
    },
  ];

  useEffect(() => {
    const transformed = BeforeDeliveryReturnsData?.map(
      (order: any, index: any) => ({
        id: index,
        order: order.order_number,
        itemName: order.product_name,
        itemPrice: order.price,
        quantity: order.qty,
        itemTotal: order.sub_total,
        returnDate: order.return_date,
        receivedDate: order.received_date,
      })
    );
    setBeforeDeliveryOrders(transformed);
  }, [BeforeDeliveryReturnsData]);


  const totalItems = beforeDeliveryOrders?.length || 0;
  const totalPages = Math.ceil(totalItems / pageSize);

  const paginatedItems = beforeDeliveryOrders
    ?.sort(
      (a: any, b: any) =>
        new Date(b.date).getTime() - new Date(a.date).getTime()
    )
    ?.slice((currentPage - 1) * pageSize, currentPage * pageSize);

  const handlePageChange = (_: any, value: number) => {
    setCurrentPage(value);
  };

  const handlePageSizeChange = (event: any) => {
    const newSize = event.target.value as number;
    setPageSize(newSize);
    setCurrentPage(1);
  };

  const errorBeforeDeliveryReturns = beforeDeliveryError?.message;

  return (
    <>
    <div className="returns-page">
      {beforeDeliveryError ? (
        <p className="error-text">{beforeDeliveryError?.message}</p>
      ) : loadingBeforeDeliveryData ? (
        <CircularProgress />
      ) : beforeDeliveryOrders && beforeDeliveryOrders?.length > 0 ? (
        <DashBoardTable
          headCells={headCellsForBeforeDelivery}
          rows={paginatedItems}
          //   ButtonActions={additionalActionsForAfter}
        />
      ) : (
        <NoProductFound />
      )}
      {beforeDeliveryOrders && beforeDeliveryOrders.length > 10 && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            pt: 5,
          }}
          className="deskPagination"
        >
          <Stack direction="row" spacing={2} alignItems="center">
            <Typography variant="body2">Items per page:</Typography>
            <Select
              value={pageSize}
              onChange={handlePageSizeChange}
              variant="outlined"
              size="small"
            >
              {array.map((size: any) => (
                <MenuItem key={size.value} value={size.value}>
                  {size.label}
                </MenuItem>
              ))}
            </Select>
          </Stack>
          <Pagination
            count={totalPages}
            shape="rounded"
            page={currentPage}
            onChange={handlePageChange}
            className="pagination-controls"
          />
        </Box>
      )}
      
      </div>
      <Box className="mobile__view__block">
        {menuItems.map(
          (menuItem, index) =>
            selectedMenuItem === menuItem && (
              <>
                {beforeDeliveryError ? (
                  <p className="error-text">{errorBeforeDeliveryReturns}</p>
                )  : (
                  <MobileTable
                    key={index}
                    headCells={headCellsForBeforeDelivery}
                    rows={paginatedItems}
                  />
                 )} 
              </>
            )
        )}
      </Box>
    </>
  );
};

export default BeforeDelivery;
